const isClientContext = typeof window !== 'undefined';

export const isMac = isClientContext && /Mac/.test(navigator.userAgent);
export const metaKeyDisplay = isMac ? '⌘' : 'Ctrl';



// WEBPACK FOOTER //
// ./lib/helpers/osEnviorment.js